import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from "../../../routes/withRouter";

//Import Action
import { cleanFilter, getSearchTerm, filterCategories } from '../../../action';

function SearchFormMobile(props) {
  const { addClass = "", iconClass = "icon-magnifier", text, btnAClass, cleanFilter, getSearchTerm, searchTerm, filterCategories } = props;
  let location = useLocation();
  let navigate = useNavigate();

  useEffect(() => {
    document.querySelector("body").addEventListener("click", onBodyClick);
    document.querySelector(".header-search .header-search-wrapper").addEventListener("click", function (e) {
      e.stopPropagation();
    })

    return (() => {
      document.querySelector("body").removeEventListener("click", onBodyClick);
    })
  }, [])

  const onSearchClick = (e) => {
    e.preventDefault();

    if (document.querySelector(".header-search"))
      document.querySelector(".header-search").classList.toggle("show");

    if (document.querySelector(".header-search-wrapper"))
      document.querySelector(".header-search-wrapper").classList.toggle("show");
  }

  const onBodyClick = (e) => {
    if (document.querySelector(".header-search-wrapper")) {
      if (document.querySelector(".header-search-wrapper").classList.contains("show")) {
        document.querySelector(".header-search-wrapper").classList.remove("show");
        document.querySelector("body").classList.remove("is-search-active");
      }

      if (document.querySelector(".header-search").classList.contains("show")) {
        document.querySelector(".header-search").classList.remove("show");
      }
    }
  }

  const [searchInput, setSearchInput] = useState(searchTerm);

  const handleSearch = e => setSearchInput(e.target.value);

  const handleSubmit = e => {
    e.preventDefault();
    if (searchInput) {
      cleanFilter();
      getSearchTerm(searchInput);
      navigate(`/szukaj/${searchInput}`);
    } else {
      cleanFilter();
      filterCategories("");
      navigate(`/produkty`);
    }
  };

  // useEffect(() => {
  //   if (location.pathname !== `/szukaj/${searchInput}`) {
  //     setSearchInput('');
  //   }
  // }, []);

  return (
    <div className={"header-search mobile " + addClass}>
      <Link to="#" className="search-toggle" title="Search" onClick={onSearchClick}>{text}</Link>
      <form onSubmit={handleSubmit}>
        <div className="header-search-wrapper-mobile">
          <input type="text" className="form-control" placeholder="Szukaj..." 
            value={searchInput}
            onChange={handleSearch}
          />
          <button className={iconClass + " btn " + btnAClass} title="Szukaj" type="submit"></button>
        </div>
      </form>
    </div>
  );
}

const mapStateToProps = ( state ) => {
  return {
    searchTerm: state.search.searchTerm ? state.search.searchTerm : ''
  }
}

export default withRouter(connect(mapStateToProps, { cleanFilter, getSearchTerm, filterCategories })(SearchFormMobile));